import { ENDPOINT } from "../configs/api";
import { httpClient } from "./httpClient";
import { RequestResponse } from "../types/httpClient";

export async function getVersion(): Promise<string | null> {
    const response: RequestResponse = await httpClient.get(ENDPOINT.iclass.setting.version, { noLoading: true })
    if (response.data.code > 0) {
        return null
    }
    return response.data.results?.version || null
}